import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  DatePicker,
  Form,
  Input,
  Tag,
} from 'antd';
import {
  AssetServiceUseResponse,
  getAssetServiceUseByCriteria,
  AssetServiceUseByCriteriaParams,
} from 'services/assets';
import moment from 'moment';
import { indexBy } from 'utils/utils2';
import { useFormList } from 'hooks/useFormList';
import InputCurrency from 'components/InputCurrency';
import ThirdPartyInput from 'components/ThirdPartyInput';
import { toCurrency } from 'utils/utils';

export type AssetServiceUseListByAssetidProps = {
  assetid:any;
};

const New_useid = -1;

const AssetServiceUseListByAssetid = (props: AssetServiceUseListByAssetidProps) => {
  const {assetid}=props;
  const [form] = Form.useForm();
  const fieldName = 'serviceuselistbyAssetid';

  const { add, remove } = useFormList(form, fieldName, {
    idKey: 'useid',
    addAsFirst: true,
  });

  const initialSearchParams: AssetServiceUseByCriteriaParams = {
    assetid: assetid ?? ('' as any),
    servcode: "",
    creationdate: "",
    validationdate: "",
    poorderreference: "",
    useid: 0 as any,
    suppliername: ""
  };

  const [searchParams, setSearchParams] =
    useState<AssetServiceUseByCriteriaParams>(initialSearchParams);

  const [searchs, setsearchs] = useState(false);

  const [editingKeys, setEditingKeys] = useState<number | null>();
  const isEditable = (useid: number): boolean => editingKeys !== useid;

  const {
    data: uselist,
    refetch,
    isFetching,
  } = useQuery(
    ['getAssetServiceUseByCriteria', Number(assetid)],
    () =>
      getAssetServiceUseByCriteria(searchParams).then(
        (res) => {
          if (res.code === '200') {
            return res.list || [];
          } 
        }
      ),
    { enabled: !!assetid || searchs }
  );
console.log({uselist})
  useEffect(() => {
    if (uselist) {
      form?.setFieldsValue({
        [fieldName]: uselist.map((serv) => {
          return {
            ...serv,
            creationdate: serv.creationdate ? moment(serv.creationdate) : '',
            requestdate: serv.requestdate ? moment(serv.requestdate) : '',
            validationdate: serv.validationdate
              ? moment(serv.validationdate)
              : '',
            supplier: {
              tpid: serv.supplierid,
              tpreference: serv.supplierreference,
              tpname: serv.suppliername,
            },
          };
        }),
      });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
    refetch();
  }, [form, uselist, refetch]);

  // const onSaveOrEdit = useCallback(
  //   (record: any) => {
  //     const servuse: any[] = form.getFieldValue(fieldName);
  //     const index = indexBy(servuse, 'useid')[record.useid];

  //     const currentValue = {
  //       ...servuse[index],
  //       associd: associd,
  //       servcode: servcode,
  //       assetid: assetid,
  //       creationdate: record.creationdate ? record.creationdate : '',
  //       requestdate: record.requestdate ? record.requestdate : '',
  //       validationdate: record.validationdate ? record.validationdate : '',
  //       suppliername: record.supplier.tpname,
  //       supplierid: record.supplier.tpid,
  //       supplierreference: record.supplier.tpreference,
  //       currcode: localStorage.getItem('currcode') ?? '',
  //       useridcrearion: Number(localStorage.getItem('userid')),
  //     };
  //     currentValue?.useid == New_useid
  //       ? addAssetServiceUse({
  //           request: { ...currentValue },
  //         }).then((response) => {
  //           if (response.code === '200') {
  //             refetch();
  //             notification.success({
  //               message: response.message,
  //             });
  //             setEditingKeys(null);
  //           }
  //         })
  //       : updateAssetServiceUse({
  //           request: currentValue,
  //         }).then((response) => {
  //           if (response.code === '200') {
  //             refetch();
  //             notification.success({
  //               message: response.message,
  //             });
  //             setEditingKeys(null);
  //           }
  //         });
  //   },
  //   [form, refetch]
  // );
  const getName = useCallback(
    (name: string) => (record: any) => {
      const serviceuse = form.getFieldValue(fieldName);
      const index = indexBy(serviceuse, 'useid')[record.useid];
      return [fieldName, index, name];
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'servlabel',
        filtrable:'servcode',
        width: 180,
      }, {
      dataIndex: 'useid',
      filtrable: true,  
      width: 100,
    },
      {
        dataIndex: 'poorderreference',
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('poorderreference')(record)} noStyle>
              <Input />
            </Form.Item>
          ) : (
            record.poorderreference
          );
        },
        width: 140,
        filtrable: true,
      },
      {
        dataIndex: 'creationdate',
        filtrable: true,
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('creationdate')(record)} noStyle>
              <DatePicker
                defaultValue={moment(new Date(), 'YYYY-MM-DD')}
                name="creationdate"
              />
            </Form.Item>
          ) : (
            moment(value).format('YYYY-MM-DD')
          );
        },
        width: 140,
      },
      {
        dataIndex: 'requestdate',
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('requestdate')(record)} noStyle>
              <DatePicker
                defaultValue={moment(new Date(), 'YYYY-MM-DD')}
                name="requestdate"
              />
            </Form.Item>
          ) : (
            moment(value).format('YYYY-MM-DD')
          );
        },
        width: 140,
      },
      {
        dataIndex: 'validationdate',
        filtrable: true,
        render: (value, record) => {
          return record?.validationdate
            ? moment(record?.validationdate).format('YYYY-MM-DD')
            : '';
        },
        width: 140,
      },
      {
        dataIndex: 'supplier',
        filtrable: true,
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('supplier')(record)} noStyle>
              <ThirdPartyInput role="SUPPLIER" />
            </Form.Item>
          ) : (
            record.suppliername
          );
        },
        width: 200,
      },
      {
        dataIndex: 'requestedamount',
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('requestedamount')(record)} noStyle>
              <InputCurrency
                currcode={record.currcode ?? localStorage.getItem('currcode')}
              />
            </Form.Item>
          ) : (
            toCurrency(
              value,
              localStorage.getItem('currcode') ?? ''
            )
          );
        },
        width: 140,
      },
      {
        dataIndex: 'acceptedamount',
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('acceptedamount')(record)} noStyle>
              <InputCurrency
                currcode={record.currcode ?? localStorage.getItem('currcode')}
              />
            </Form.Item>
          ) : (
            toCurrency(
              value,
              localStorage.getItem('currcode') ?? ''
            )
          );
        },
        width: 140,
      },
      {
        dataIndex: 'useramounttobeinvoiced',
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item name={getName('useramounttobeinvoiced')(record)} noStyle>
              <InputCurrency
                currcode={record.currcode ?? localStorage.getItem('currcode')}
              />
            </Form.Item>
          ) : (
            toCurrency(
              value,
              localStorage.getItem('currcode') ?? ''
            )
          );
        },
        width: 140,
      },
      {
        dataIndex: 'suppliervalidatedamount',
        render: (value, record) => {
          return !isEditable(record.useid) ? (
            <Form.Item
              name={getName('suppliervalidatedamount')(record)}
              noStyle
            >
              <InputCurrency
                currcode={record.currcode ?? localStorage.getItem('currcode')}
              />
            </Form.Item>
          ) : (
            toCurrency(
              value,
              localStorage.getItem('currcode') ?? ''
            )
          );
        },
        width: 140,
      },
 
      {
        dataIndex: 'requeststatus',
        render: (value, record) => {
          return (
            isEditable(record.useid) && (
              <Tag
                color={
                  record.requeststatus === 'INIT'
                    ? 'lime'
                    : record.requeststatus === 'VALID'
                    ? 'green'
                    : 'red'
                }
              >
                {record.requeststatus}
              </Tag>
            )
          );
        },
        width: 140,
        fixed: 'right',
      },
     
    ],
    [uselist, form, refetch, getName, editingKeys, remove]
  );

  // const addRow = () => {
  //   const row: AssetServiceUseResponse = {
  //     useid: New_useid,
  //     associd: associd,
  //     assetid: 0,
  //     cteid: 0,
  //     servcode: '',
  //     currcode: '',
  //     creationdate: '',
  //     useridcrearion: Number(localStorage.getItem('userid')),
  //     requestdate: '',
  //     requeststatus: 'INIT',
  //     validationdate: '',
  //     useridvalidation: 0,
  //     supplierid: 0,
  //     suppliername: '',
  //     supplierreference: '',
  //     requestedamount: 0,
  //     requestedqty: 0,
  //     acceptedamount: 0,
  //     acceptedqty: 0,
  //     useramounttobeinvoiced: 0,
  //     suppliervalidatedamount: 0,
  //     usecomment: '',
  //     poorderreference: '',
  //     externalreference: '',
  //     siid: 0,
  //     ciid: 0,
  //     taskid: 0,
  //     kilometerscounter: 0,
  //   };
  //   add(row);
  //   setEditingKeys(-1);
  // };

  return (
    <DF.Provider pagcode="historyserviceuse">
      <Form form={form}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const value: AssetServiceUseResponse[] = getFieldValue(fieldName);
            const isNewItem =
              value?.find(({ useid }) => useid === New_useid) !== undefined;
            return (
              <DataGrid
                hideTitle
                rowKey="useid"
                scroll={{ x: 2000, y: 400 }}
                isLoading={isFetching}
                dataSource={value}
                columns={columns}
                onSearch={(values) => {
                  setSearchParams(searchParams);
                  setsearchs(true);
                }}
                initialSearchValues={initialSearchParams}
              
              />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default AssetServiceUseListByAssetid;
